// Helpers for rendering an avatar that reflects either the signed-in user
// (admin's session) or, in admin "view as" mode, the impersonated user.

export function getInitials(name: string | undefined): string {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/).filter(p => p.length > 0);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
